var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.2197 16.2803C13.9268 15.9874 13.9268 15.5126 14.2197 15.2197L16.9393 12.5H4.75C4.33579 12.5 4 12.1642 4 11.75C4 11.3358 4.33579 11 4.75 11H16.9393L14.2197 8.28033C13.9268 7.98744 13.9268 7.51256 14.2197 7.21967C14.5126 6.92678 14.9874 6.92678 15.2803 7.21967L19.2803 11.2197C19.5732 11.5126 19.5732 11.9874 19.2803 12.2803L15.2803 16.2803C14.9874 16.5732 14.5126 16.5732 14.2197 16.2803Z",
      "fill": "#006ED2",
      "stroke": "none"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };